module.exports = __webpack_public_path__ + "media/bg.1757627f.mp4";